import { render, staticRenderFns } from "./SalesRefund.vue?vue&type=template&id=5cd96c69&scoped=true&"
import script from "./SalesRefund.vue?vue&type=script&lang=js&"
export * from "./SalesRefund.vue?vue&type=script&lang=js&"
import style0 from "./SalesRefund.vue?vue&type=style&index=0&id=5cd96c69&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd96c69",
  null
  
)

export default component.exports